import { AppConfig } from '../../app.config';

export const redirectToApplicationDetails = (publicId: string | undefined | null): void => {
  window.location.href = `${AppConfig.dealerPortalUrl}/DealerCabinet/ApplicationDetails?publicId=${publicId}`;
};

export const setAppStatusParams = (status?: string): void => {
  if (status) {
    const url = new URL(window.location.href);
    url.searchParams.set('appStatus', status);
    window.history.pushState({}, '', url);
  }
};
